import React from 'react';
import { Row, Col, Input } from 'reactstrap';
import { FormCheckbox, SubHeading } from '../common/forms/FormElements';
import ContractPhaseRow from './ContractPhaseRow';

export class PhaseDisplay extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            filter: null,
            onlyShowHidden: false,
        };
    }

    render() {
        const { phases } = this.props;
        const { filter, onlyShowHidden } = this.state;

        const phaseCount = phases && phases.length ? phases.length : 0;
        const activePhaseCount =
            phaseCount > 0 ? phases.filter((p) => p.isActive).length : 0;

        const hiddenPhaseCount =
            phaseCount > 0 ? phases.filter((p) => p.isHidden).length : 0;

        const filteredPhases = (phases || []).filter(
            (p) =>
                (!filter ||
                    p.displayPhase
                        .toLowerCase()
                        .includes(filter.toLowerCase()) ||
                    p.description
                        .toLowerCase()
                        .includes(filter.toLowerCase())) &&
                (!onlyShowHidden || p.isHidden)
        );

        const activeFilteredCount = filteredPhases.length;
        const filteredRecordCount = phaseCount - activeFilteredCount;

        return (
            <>
                <Row>
                    <Col>
                        <SubHeading>Phases</SubHeading>
                    </Col>
                </Row>
                <Row className="mb-2">
                    <Col>
                        <div className="container-fluid ml-3 pl-1 text-muted font-weight-bold align-items-center">
                            <div>
                                {phaseCount} total, {activePhaseCount} active.
                                {filteredRecordCount > 0 && (
                                    <span className="ml-1">
                                        {filteredRecordCount} phases hidden by
                                        active filter.
                                    </span>
                                )}
                            </div>
                            <div>
                                {hiddenPhaseCount == 0 && (
                                    <>No phases are configured to be hidden.</>
                                )}

                                {hiddenPhaseCount > 0 && (
                                    <>
                                        {hiddenPhaseCount} phases are configured
                                        to be hidden.
                                    </>
                                )}
                            </div>
                        </div>
                    </Col>
                    <Col>
                        <Row>
                            <Col>
                                <Input
                                    type="text"
                                    className="float-right mr-3 w-75"
                                    size="sm"
                                    value={filter}
                                    onChange={(e) =>
                                        this.setState({
                                            filter: e.target.value,
                                        })
                                    }
                                    placeholder="Filter phases"
                                />
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col>
                                <FormCheckbox
                                    className="float-right mr-3"
                                    checked={onlyShowHidden}
                                    onChange={(e) =>
                                        this.setState({
                                            onlyShowHidden: e.target.checked,
                                        })
                                    }
                                    labelText="Only show hidden phases"
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="container-fluid simple-table-container">
                            <table className="table table-sm">
                                <thead>
                                    <tr className="sticky-thead">
                                        <th>Phase</th>
                                        <th>Description</th>
                                        <th>Unit of Measure</th>
                                        <th>Bid Quantity</th>
                                        <th>Scheduled Quantity</th>
                                        <th>Active</th>
                                        <th>Hidden</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(!phases || !phases.length) && (
                                        <tr>
                                            <td colSpan={7}>
                                                No phases configured.
                                            </td>
                                        </tr>
                                    )}
                                    {filteredPhases &&
                                        filteredPhases.map((p) => (
                                            <ContractPhaseRow
                                                key={p.id}
                                                contractPhase={p}
                                                {...this.props}
                                            />
                                        ))}
                                </tbody>
                            </table>
                        </div>
                    </Col>
                </Row>
            </>
        );
    }
}
